// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._rLBAkQS7dSFbgCv5FrR {
  height: 32px;
  line-height: 32px;
  padding-left: 8px;
}
.hvkccW3mBYuntxQq4bfo {
  display: inline-block;
  padding: 2px 16px;
  text-align: center;
  border-radius: 4px;
  line-height: 1.5;
  color: #fff;
}
.hvkccW3mBYuntxQq4bfo.bv5zbqKZvfZAtX5PQAbF {
  background: #e90000;
}
.hvkccW3mBYuntxQq4bfo.DpK0fI98Kt7HurBtCcZC {
  background: #ff4100;
}
.hvkccW3mBYuntxQq4bfo.Tg6SSE4ZMDRalEKWzG_u {
  background: #0073ef;
}
.hvkccW3mBYuntxQq4bfo.v6gs1JvBlKUjMHGoK_6a {
  background: #00b300;
}
.YExtVGjKzuL7JS_BnApv {
  display: inline-block;
  padding: 2px 16px;
  line-height: 1.5;
  text-align: center;
  border-radius: 4px;
}
.YExtVGjKzuL7JS_BnApv.yN6gnnS31RMul7Y4Qaub {
  color: #ff7f00;
  background: rgba(255, 127, 0, 0.15);
}
.YExtVGjKzuL7JS_BnApv.x1K3e8I8J6WlS4okWno9 {
  color: #009157;
  background: rgba(0, 145, 87, 0.15);
}
.YExtVGjKzuL7JS_BnApv.SKFIMvas_WRdlKSujiO1 {
  color: #ee2100;
  background: rgba(238, 33, 0, 0.15);
}
.YExtVGjKzuL7JS_BnApv.ZJDOZuIWCpRchGBZGFIH {
  color: #0060ed;
  background: rgba(0, 96, 237, 0.15);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Project/Task/components/TaskField/index.module.less"],"names":[],"mappings":"AACA;EACE,YAAA;EACA,iBAAA;EACA,iBAAA;AAAF;AAGA;EACE,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AADF;AAGE;EACE,mBAAA;AADJ;AAGE;EACE,mBAAA;AADJ;AAGE;EACE,mBAAA;AADJ;AAGE;EACE,mBAAA;AADJ;AAKA;EACE,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAHF;AAKE;EACE,cAAA;EACA,mCAAA;AAHJ;AAKE;EACE,cAAA;EACA,kCAAA;AAHJ;AAKE;EACE,cAAA;EACA,kCAAA;AAHJ;AAKE;EACE,cAAA;EACA,kCAAA;AAHJ","sourcesContent":["\n.fieldItem {\n  height: 32px;\n  line-height: 32px;\n  padding-left: 8px;\n}\n\n.taskPriority {\n  display: inline-block;\n  padding: 2px 16px;\n  text-align: center;\n  border-radius: 4px;\n  line-height: 1.5;\n  color: #fff;\n\n  &.Highest {\n    background: #e90000;\n  }\n  &.High {\n    background: #ff4100;\n  }\n  &.Normal {\n    background: #0073ef;\n  }\n  &.Low {\n    background: #00b300;\n  }\n}\n\n.taskStatus {\n  display: inline-block;\n  padding: 2px 16px;\n  line-height: 1.5;\n  text-align: center;\n  border-radius: 4px;\n\n  &.OPEN {\n    color: #ff7f00;\n    background: rgba(255, 127, 0, 0.15);\n  }\n  &.IN_PROGRESS {\n    color: #009157;\n    background: rgba(0, 145, 87, 0.15);\n  }\n  &.CLOSED {\n    color: #ee2100;\n    background: rgba(238, 33, 0, 0.15);\n  }\n  &.ON_HOLD {\n    color: #0060ed;\n    background: rgba(0, 96, 237, 0.15);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fieldItem": `_rLBAkQS7dSFbgCv5FrR`,
	"taskPriority": `hvkccW3mBYuntxQq4bfo`,
	"Highest": `bv5zbqKZvfZAtX5PQAbF`,
	"High": `DpK0fI98Kt7HurBtCcZC`,
	"Normal": `Tg6SSE4ZMDRalEKWzG_u`,
	"Low": `v6gs1JvBlKUjMHGoK_6a`,
	"taskStatus": `YExtVGjKzuL7JS_BnApv`,
	"OPEN": `yN6gnnS31RMul7Y4Qaub`,
	"IN_PROGRESS": `x1K3e8I8J6WlS4okWno9`,
	"CLOSED": `SKFIMvas_WRdlKSujiO1`,
	"ON_HOLD": `ZJDOZuIWCpRchGBZGFIH`
};
export default ___CSS_LOADER_EXPORT___;
